import { useHasPermission } from '../../../../hooks/useHasPermission';
import { FormatDate } from '../../../../utils/formatDate';
import { EditMachineReport } from '../editMachineReport';
import { Box, Typography } from '@mui/material';
import MachineStatus from '../../machineStatus';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import Iconify from '../../../Iconify';
import '../../../../css/machines/readMachineReport.css';

const MachineReportDetailsInfo = () => {

    const hasUpdateReportPermission = useHasPermission('controls_update');
    const machineReportDetailsData = useSelector((state) => state.MachineReportDetailsData);

    const [editReportData, setEditReportData] = useState(false);

    return (
        <Box className='readMachineReport_box'>
            <Box className='readMachineReport_edit_box'>
                <Typography className='readMachineReport_title'>Les informations du rapport</Typography>
                {hasUpdateReportPermission && !machineReportDetailsData?.machine?.is_archived && <Iconify className='readMachineReport_edit_icon' icon={"ic:outline-edit"} onClick={() => setEditReportData(true)} />}
            </Box>
            <Box className='readMachineReport_info_box'>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"formkit:date"} />
                    <Typography className='readMachineReport_text'>Date de contrôle:</Typography>
                    <Typography className='readMachineReport_text_statut_controle'>{FormatDate(machineReportDetailsData?.control_date)}</Typography>
                </Box>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"iconoir:washing-machine"} />
                    <Typography className='readMachineReport_text'>Machine:</Typography>
                    <Typography className='readMachineReport_text_statut_controle'>{machineReportDetailsData?.machine?.name || '--'}</Typography>
                </Box>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"uil:building"} />
                    <Typography className='readMachineReport_text'>Entreprise associé:</Typography>
                    <Typography className='readMachineReport_text_statut_controle'>{machineReportDetailsData?.company.name}</Typography>
                </Box>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"charm:person"} />
                    <Typography className='readMachineReport_text'>Vérificateur:</Typography>
                    <Typography className='readMachineReport_text_statut_controle'>{machineReportDetailsData?.verifier.name}</Typography>
                </Box>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"charm:person"} />
                    <Typography className='readMachineReport_text'>Accompagnateur:</Typography>
                    <Typography className='readMachineReport_text_statut_controle'>{machineReportDetailsData?.accompanist.first_name} {machineReportDetailsData?.accompanist.last_name}</Typography>
                </Box>
                <Box className='readMachineReport_icon_title_response_box'>
                    <Iconify className='readMachineReport_action_icon' icon={"pajamas:status"} />
                    <Typography className='readMachineReport_text'>Statut:</Typography>
                    <MachineStatus status={machineReportDetailsData?.status} />
                </Box>
            </Box>
            {editReportData &&
                <EditMachineReport
                    editReportData={editReportData}
                    setEditReportData={setEditReportData}
                />
            }
        </Box>
    );
}

export default MachineReportDetailsInfo;